export default {
  'menu.workbench': '工作台',
  'menu.more-blocks': '更多区块',
  'menu.home': '首页',
  'menu.admin': '管理页',
  'menu.admin.sub-page': '二级管理页',
  'menu.system': '系统管理',
  'menu.system.menu': '菜单管理',
  'menu.system.user': '用户管理',
  'menu.system.role': '角色管理',
  'menu.login': '登录',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析页',
  'menu.dashboard.monitor': '监控页',
  'menu.dashboard.workplace': '工作台',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表单页',
  'menu.form.basic-form': '基础表单',
  'menu.form.step-form': '分步表单',
  'menu.form.step-form.info': '分步表单（填写转账信息）',
  'menu.form.step-form.confirm': '分步表单（确认转账信息）',
  'menu.form.step-form.result': '分步表单（完成）',
  'menu.form.advanced-form': '高级表单',
  'menu.list': '列表页',
  'menu.list.table-list': '查询表格',
  'menu.list.basic-list': '标准列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（项目）',
  'menu.list.search-list.applications': '搜索列表（应用）',
  'menu.profile': '详情页',
  'menu.profile.basic': '基础详情页',
  'menu.profile.advanced': '高级详情页',
  'menu.result': '结果页',
  'menu.result.success': '成功页',
  'menu.result.fail': '失败页',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '个人页',
  'menu.account.center': '个人中心',
  'menu.account.workbench': '回到工作台',
  'menu.account.tenantManagement': '企业管理',
  'menu.account.trigger': '触发报错',
  'menu.account.logout': '退出登录',
  'menu.editor': '图形编辑器',
  'menu.editor.flow': '流程编辑器',
  'menu.editor.mind': '脑图编辑器',
  'menu.editor.koni': '拓扑编辑器',
  'menu.enterprise-knowledge-graph': '企业知识图谱中心',
  'menu.enterprise-knowledge-graph.dashboard': '工作台',
  'menu.enterprise-knowledge-graph.entities': '我的实体',
  'menu.enterprise-knowledge-graph.entities.list': '全部实体',
  'menu.enterprise-knowledge-graph.entities.companies': '企业实体',
  'menu.enterprise-knowledge-graph.entities.persons': '人物实体',
  'menu.enterprise-knowledge-graph.entities.products': '产品实体',
  'menu.enterprise-knowledge-graph.entities.documents': '文档实体',
  'menu.enterprise-knowledge-graph.platform': '平台知识引用',
  'menu.enterprise-knowledge-graph.platform.search': '平台实体检索',
  'menu.enterprise-knowledge-graph.platform.referenced': '已引用实体',
  'menu.enterprise-knowledge-graph.platform.extensions': '平台实体扩展',
  'menu.enterprise-knowledge-graph.relations': '我的关系',
  'menu.enterprise-knowledge-graph.business-links': '业务对象关联',
  'menu.enterprise-knowledge-graph.graph': '图谱可视化',
  'menu.enterprise-knowledge-graph.import': '知识导入',
  'menu.enterprise-knowledge-graph.import.data-sources': '数据源管理',
  'menu.enterprise-knowledge-graph.import.tasks': '导入任务',
  'menu.enterprise-knowledge-graph.improvement': '知识完善',
  'menu.enterprise-knowledge-graph.improvement.incomplete-entities':
    '待完善实体',
  'menu.enterprise-knowledge-graph.improvement.duplicates': '疑似重复实体',
  'menu.enterprise-knowledge-graph.ai-assistant': 'AI 知识助手',
  'menu.enterprise-knowledge-graph.settings': '企业图谱设置',
};
